import { endpoints, useApi } from 'api';

export default function useSendResetPasswordEmail(onSuccess, onFailed, triggerLoader) {
    const [api] = useApi();

    const sendResetPasswordEmail = async (data) => {
        try {
            if (triggerLoader) triggerLoader(true);
            const req = await api({
                method: 'post',
                url: `${endpoints.SEND_RESET_PASSWORD}`,
                data,
            });

            const res = await req.data;

            if (triggerLoader) triggerLoader(false);

            if (res && onSuccess) {
                onSuccess();
            }
        } catch (error) {
            if (triggerLoader) triggerLoader(false);
            if (onFailed) onFailed(error);
        }
    };

    return [sendResetPasswordEmail];
}
